


import React, { useContext, useState } from 'react';
import { Button } from '@mui/material';
import ErrorModal from '../shared/components/UIElements/errorModal';
import LoadingSpinner from '../shared/components/UIElements/loadingSpinner';
import { VALIDATOR_EMAIL, VALIDATOR_MINLENGTH } from '../shared/util/validators';
import Input from '../shared/components/FormElements/input';
import { useForm } from '../shared/hooks/form-hook';
import { useHttpClient } from '../shared/hooks/http-hook';
import { AuthContext } from '../shared/context/auth-context';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';

import './Auth.css';



const Login = () => {
  const auth = useContext(AuthContext);
  const history = useHistory();
  const [isLoginMode, setIsLoginMode] = useState(true);
  const { isLoading, error, sendRequest, clearError } = useHttpClient();

  const [formState, inputHandler, setFormData] = useForm(
    {
      email: {
        value: '',
        isValid: false,
      },
      password: {
        value: '',
        isValid: false,
      },
    },
    false
  );



  // Switching Login and Signup
  const switchModeHandler = () => {
    if (!isLoginMode) {
      setFormData(
        {
          ...formState.inputs,
          name: undefined,
        },
        formState.inputs.email.isValid && formState.inputs.password.isValid
      );
    } else {
      setFormData(
        {
          ...formState.inputs,
          name: {
            value: '',
            isValid: false,
          },
        },
        false
      );
    }
    setIsLoginMode(prevMode => !prevMode);
  };

  // Submit handler
  const submitHandler = async (event) => {
    event.preventDefault();

    let apiUrl = isLoginMode ? process.env.REACT_APP_BACKEND_URL + '/users/login' : process.env.REACT_APP_BACKEND_URL + '/users/signup';

    if (formState.inputs.email.value.includes('@admin.com')) {
      apiUrl = isLoginMode ?  process.env.REACT_APP_BACKEND_URL + '/admin/login' : process.env.REACT_APP_BACKEND_URL + '/admin/signup';
    }





    if(isLoginMode){

    // Login
      try {
        const responseData = await sendRequest (
          apiUrl,
          'POST',
          JSON.stringify({
            email: formState.inputs.email.value,
            password: formState.inputs.password.value,
          }),
          {
            'Content-Type': 'application/json',   
          }
        );   
        auth.login(responseData.user, responseData.token);
        
        

        if(responseData.user.role === 'admin'){
          history.push('/admin/dashboard')
          
        } else {
          history.push('/posts');
         
        }

      } catch (err) { 
        console.log('This is login error',err.message)
      }

    } else {

      // Sign up
      try {  
        const responseData = await sendRequest(
          apiUrl,
          'POST',
          JSON.stringify({
            email: formState.inputs.email.value,
            password: formState.inputs.password.value,
            name: formState.inputs.name.value
          }),
          {
            'Content-Type': 'application/json',  
          },
          
        );
         
        // auth.login(responseData.user, responseData.token);
    
        setIsLoginMode(true)
        console.log('responsive data: ', responseData)
        // Pushing to the certain pages
        if(responseData.user.role === 'admin'){
          history.push('/admin/dashboard')
        } else {
           history.push('/auth');
        }
       

     
      } catch (err) { 
        console.log('This is signup error',err.message)
      }
    }  
  };
 

  return (
    <React.Fragment>
      <ErrorModal error={error} onClear={clearError}/>
    <main className="login-auth-container">
      <div className="login-auth-form">
        <div className="login-img-container">
          <img src="/image/wheel.jpg" alt="gate" />
        </div>

        {isLoading && <LoadingSpinner asOverlay/>}
        <form onSubmit={submitHandler} className="auth-form-container">
          <div className="container-u-p">
            {!isLoginMode && (
              <>
                <label htmlFor="name">
                  <b>Name</b>
                </label>
                <Input
                  element="input"
                  id="name"
                  type="name"
                  placeholder="Enter your name"
                  validators={[VALIDATOR_MINLENGTH(3)]}
                  errorText="Please enter a valid name (at least 3 characters)."
                  onInput={inputHandler}
                />
              </>
            )}

            <label htmlFor="email">
              <b>Email</b>
            </label>
            <Input
              element="input"
              id="email"
              type="email"
              autoComplete="off"
              placeholder="Enter your email address"
              validators={[VALIDATOR_EMAIL()]}
              errorText="Please enter a valid email."
              onInput={inputHandler}
            />

            <label htmlFor="password">
              <b>Password</b>
            </label>
            <Input
              element="input"
              id="password"
              type="password"
              placeholder="Enter your password"
              validators={[VALIDATOR_MINLENGTH(6)]}
              errorText="Please enter a valid password (at least 6 characters)."
              onInput={inputHandler}
            />
            
            <div style={{ textAlign: 'end', marginTop: '-10px', marginBottom: '15px' }}>
              <a href="/" style={{ textDecoration: 'none' }}>
                Forgot password
              </a>
            </div>

            <Button type="submit" variant="contained" disabled={!formState.isValid}>
              {isLoginMode ? 'Login' : 'Sign Up'}
            </Button>

            {/* <div className="check">
              <input type="checkbox" name="remember" /> Remember me
            </div> */}

            <div className="create-user">
              {isLoginMode ? (
                <>
                  Шинэ хэрэглэгч? {' '}
                  <div onClick={switchModeHandler} style={{textDecoration: 'underline', cursor: 'pointer', pointerEvents: 'fill', color: 'blue'}}>
                    Create new account.
                  </div>
                </>
              ) : (
                <>              
                  <div onClick={switchModeHandler} style={{textDecoration: 'underline', cursor: 'pointer', pointerEvents: 'fill', color: 'blue'}}>
                    Already have an account?
                  </div>
                </>
              )}          
            </div>
          </div>
        </form>
      </div>
    </main>
    </React.Fragment>
  );
};

export default Login;
